import AdyenPaymentError from './AdyenPaymentError';

export default AdyenPaymentError;
